import { get, post } from 'App/Network/Axios'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { Button, Input, KeyValue, Modal, SelectInput, SidePane, TOAST } from 'retro/index'

function EffectiveTds({onClose,id}) {
    const [loading, setLoading] = useState(true)
    const [eRates, setERates] = useState([])
    const [add,setAdd] = useState(false)
    const [deleteConfirm, setDeleteConfirm] = useState(false)
    const [deleteId, setDeleteId] = useState(null)
    const [baseExclusive, setBaseExclusive] = useState(true);
    const DATE = useRef(), EXEMPTION_LIMIT = useRef(), HUFF_RATE = useRef(), OTHER_RATE = useRef(), TLIMIT = useRef(), MONTH_REF = useRef(true), PIN = useRef()

    const loadRates = () => {
        get(`data/tds/getAllTdsRateEntries/${id}`,(e,r)=>{
            if(r){
                setERates(r.tdsRates)
                setLoading(false)
            }
            else{
                TOAST.handleError(e)
                setLoading(false)
            }
        })
    }

    useEffect(()=>{
        loadRates()
    },[id])

    const handleAdd = () =>{
        let threshold = TLIMIT.current.value
        let effectiveDate = DATE.current.value
        let exemptionLimit = EXEMPTION_LIMIT.current.value
        let hufRate = HUFF_RATE.current.value
        let otherRate = OTHER_RATE.current.value
        if(!effectiveDate){
            TOAST.error('Please select effective date')
            return
        }
        if (excluded.includes(effectiveDate)) {
            TOAST.error("Selected Effective date is already taken.");
            DATE.current.value = moment().format('YYYY-MM-DD')
            return
        }
        if(!exemptionLimit){
            TOAST.error('Please enter exemption limit')
            return
        }
        if(!hufRate){
            TOAST.error('Please enter individual huf rate')
            return
        }
        if(!otherRate){
            TOAST.error('Please enter other rate')
            return
        }
        let data = {
            threshold_limit : Number(threshold),
            tds_master_id : Number(id),
            effective_date: effectiveDate,
            exemption_limit: Number(exemptionLimit),
            individual_huf_rate: Number(hufRate),
            other_rate: Number(otherRate),
            base_exclusive: baseExclusive,
            monthly: baseExclusive === false ? MONTH_REF.current:false,
        }
        setLoading(true)
        post(`data/tds/addTdsEffectiveRate`,data,(e,r)=>{
            if(r){
                TOAST.success('Effective TDS added successfully')
                setAdd(false)
                loadRates()
                setLoading(false)
                setBaseExclusive(true)
            }
            else{
                TOAST.handleError(e)
                setLoading(false)
                return
            }
        })
    }

    const handleDelete = () => {

        const pin = PIN.current.value;

        if(!pin){
            TOAST.error('Please enter pin');
            return
        }

        post(`data/tds/${deleteId}/deleteTdsRate`,{pin},(e,r)=>{
            if(r){
                TOAST.success('Effective TDS Rate Deleted Successfully')
                loadRates()
                setDeleteConfirm(false)
            }else if (e){
                TOAST.handleError(e)
            }
        })
    }

    const excluded = eRates.map(e =>
        new Date(e.effectiveDate).toISOString().split("T")[0]
      );

    const handleDateChange = (val) => {
        if (excluded.includes(val)) {
            TOAST.error("This date is already taken.");
            DATE.current.value = moment().format('YYYY-MM-DD')
        }
    }

    return (
        <>
            <SidePane onClose={onClose} title='Effective TDS' description='All the effective tds are mentioned below'>
                <Button onClick={()=>setAdd(true)}>Add Effective TDS</Button>
                <div className='mt3'>
                {eRates.length > 0 &&
                   eRates.map((item,index)=>{
                    return(
                        <div className="retro-card FadeInUp-Effect">
                            <KeyValue index={index} title='Effective Date : ' value={item.effectiveDate}/>
                            <KeyValue index={index} title='Exemption Limit : ' value={item.exemption_limit || 'Not Set'}/>
                            <KeyValue index={index} title='Threshold Limit : ' value={item.threshold_limit || 'Not Set'}/>
                            <KeyValue index={index} title='Individual Huf Rate : ' value={item.individualHufRate || 'Not Set'}/>
                            <KeyValue index={index} title='Other Rate : ' value={item.otherRate || 'Not Set'}/>
                            <KeyValue index={index} title='Base Exclusive: ' value={item.baseExclusive }/>
                            <KeyValue index={index} title='Monthly: ' value={item.monthly }/>
                            <Button className='decline-btn btn-sm' onClick={()=>{
                                setDeleteId(item.id)
                                post(`data/tds/${item.id}/deleteTdsRate`,{},(e,r)=>{
                                    if(r){
                                        TOAST.success('Effective TDS Rate Deleted Successfully')
                                        loadRates()
                                        setDeleteConfirm(false)
                                    }else if (e){
                                        TOAST.success(e.data.message)
                                    }
                                })
                                setDeleteConfirm(true)
                            }}>Delete</Button>
                        </div>
                    )
                   })
                }
                </div>

            </SidePane>
            {add && 
                <Modal title='Add Effective TDS' 
                    description='Fill all the required details' 
                    onClose={()=>{setAdd(false),setBaseExclusive(true)}} 
                    onSubmit={handleAdd}
                    button='Add'
                    btnLoader={loading}
                    >
                        <Input label='Effective Date' placeholder='select date' ref={DATE} type='date' onChange={handleDateChange} defaultValue={DATE?.current?.value}/>
                        <Input label='Exemption Limit' placeholder='enter exemption limit' ref={EXEMPTION_LIMIT} type='number'/>
                        <Input label='Threshold Limit' placeholder='enter threshold limit ' ref={TLIMIT} type='number'/>
                        <Input label='Individual Huf Rate' placeholder='enter huf rate' ref={HUFF_RATE} type='number'/>
                        <Input label='Other Rate' placeholder='enter other rate' ref={OTHER_RATE} type='number'/>
                        <SelectInput
                            options={[
                                { value: true, label: "True" },
                                { value: false, label: "False" },
                            ]}
                            onChange={(val) => setBaseExclusive(val === 'true')}
                            type="text"
                            label="Base Exclusive"
                            className="mt2"
                        />
                        {baseExclusive === false ?
                            <SelectInput
                                options={[
                                    { value: true, label: "True" },
                                    { value: false, label: "False" },
                                ]}
                                onChange={(val) => (MONTH_REF.current = val === "true")}
                                type="text"
                                label="Monthly"
                                className="mt2"
                            />
                            : null
                        }
                </Modal>
            }
            {deleteConfirm && 
                <Modal 
                    title='Enter PIN To Delete' 
                    description='Are you sure you want to delete this Effective TDS rate?' 
                    onClose={()=>setDeleteConfirm(false)} 
                    onSubmit={handleDelete}
                    button='Delete'
                    >
                    <Input label='Pin' placeholder='enter pin' ref={PIN} type='password'/>
                </Modal>
            }
        </>
    )
}

export default EffectiveTds